import React, { useEffect, useContext } from 'react';
import './foundation.scss';
import DialogContentText from '@material-ui/core/DialogContentText';
import ReactMarkdown from 'react-markdown';

// CONTEXT
import AboutusContext from '../../../../../contexts/pages/aboutus/aboutusContext';

import Slider from '../../../../Globals/Slider'

const Foundation = () => {

    const aboutusContext = useContext(AboutusContext);
    const { foundation, history} = aboutusContext;
    useEffect(() => {
    }, [foundation])
    return (
        <div className="aboutus-subpage foundation">
            {/* {foundation ? (<Slider bannerData={foundation.banner} />) :null} */}
            {history ? (<Slider bannerData={history.banner} />) :null}
            <div className="foundation-inner">
                <div className="foundation-title">{foundation ? foundation.titulo : "FUNDACION PEDAGOGICA DOMINICANA"}</div>
                <div className="foundation-text">
                    {foundation
                        ?
                        // <DialogContentText>
                            <ReactMarkdown>
                                {foundation.descripcion}
                            </ReactMarkdown>
                        // </DialogContentText>
                        :
                        <p>
                            La Secundaria Babeque  es un centro educativo auspiciado por la Fundación Pedagógica Dominicana Inc.,
                            institución sin fines de lucro creada en el año de 1977  por un grupo de madres y padres cuyos hijos
                            terminaban el sexto grado del Colegio Babeque Inicial y Primaria. Con esta iniciativa se proponían
                            velar por el desarrollo de los valores universales, la dominicanidad y la formación integral de sus hijos e hijas.

                            Se seleccionó el nombre Babeque, voz de origen taíno que significa tierra de oro, por considerar a
                            la niñez y la juventud como la esperanza y el tesoro más preciado de una nación.
                        </p>
                    }
                </div>
            </div>
        </div>
    )
}

export default Foundation;